const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      faq: "FAQ",
      contact: "Contact us",
      switchLanguage: "Ver el sitio en español",
      call: "Call Tax Solutions",
      callNow: "Call now",
    },
    common: {
      bookAppointment: "Book an Appointment",
      videoUnsupported: "Your browser does not support the video tag.",
    },
    hero: {
      heading: "Accounting Services for",
      words: ["Business Owners like You", "Individuals like You"],
    },
    mission:
      "Tax Solutions AS Corp. is committed to delivering excellence across all services regardless of the nature of your business. Trusting us is the key to your financial success.",
    homeServices: [
      {
        category: "Corporations, Partnerships, LLCs",
        title: "ACCOUNTING SERVICES",
        description:
          "Whether it's reconciling accounts, correcting mistakes, or clearing up backlogs, we cover all your bookkeeping needs. Plus, you will enjoy clear, monthly financial reports to keep you informed.",
      },
      {
        category: "Individuals & Corporate Clients",
        title: "TAX SERVICES",
        description:
          "We will ensure your financial statements are ready for tax purposes and verify that you're fully compliant with all individual and corporate tax regulations so you can confidently approach tax season.",
      },
    ],
    proactive: {
      message:
        "Stay proactive and prepared to elevate your business while ensuring full compliance with IRS tax regulations. Let's work ahead to set you up for smooth, stress-free success.",
      imageAlt: "Yoel Alvarez working at his desk",
    },
    about: {
      heading: "Personalized, Professional Accounting",
      founderTitle: "About the Founder",
      founder: [
        "Yoel Alvarez, founder of Tax Solutions AS Corp., holds a Master of Accounting – Taxation and brings over 10 years of professional experience in accounting, taxation, and financial management.",
        "Since 2014, he has assisted hundreds of individuals and businesses with tax preparation, financial reporting, and accounting services. His professional expertise includes individual and business taxation, tax planning, bookkeeping, financial statement preparation, and IRS compliance.",
        "Throughout his career, Yoel has developed extensive experience in managing financial operations, navigating complex tax regulations, and helping clients make informed financial decisions.",
        "In 2021, he founded Tax Solutions AS Corp., building upon his professional experience and specialized knowledge in taxation. His background reflects a strong foundation in accounting principles, analytical problem-solving, and a commitment to maintaining high professional standards.",
      ],
      missionTitle: "Our Mission",
      mission:
        "Simplify the complexities of tax requirements by offering professional, reliable guidance, allowing you to focus on what matters most to your business. By understanding each client's unique financial needs, we provide tailored solutions that ensure accuracy, efficiency, and peace of mind during tax season and beyond.",
      visionTitle: "Our Vision",
      vision:
        "Dedicated to delivering comprehensive, forward-thinking solutions powered by technology. We focus on building lasting client relationships and fostering a collaborative, people-centered company culture.",
      imageAlt: "Professional",
    },
    services: {
      hero: "Let us handle your finances while you focus on growing your business. We offer a comprehensive range of services in one place, ensuring quality and reliability every step of the way.",
      heading: "What services and solutions can we offer to meet your needs",
      items: {
        accounting: "Accounting Services",
        statements: "Financial Statements",
        filing1099: "1099 Filing",
        salesTax: "Sales Tax Compliance",
        reporting: "Custom Reporting/Analytics",
        taxReturn: "Tax Return Filing",
        compliance: "State and Federal Tax Compliance",
        extension: "Tax Extension",
        estimate: "Tax Estimate",
        credits: "Tax Credits",
        consulting: "Business Consulting",
      },
      cta: "Ready to get started? Contact us for a consultation.",
    },
    faq: {
      heading: "Frequently Asked Questions",
      checklistTitle: "TAX DOCUMENTS CHECKLIST",
      checklistIntro:
        "Documents required and/or necessary to file your Personal Income Tax Return. You must present those that apply to your case.",
      documents: [
        "Jobs that withhold taxes from earned income.",
        "You were paid the full amount without tax retentions for jobs that do not withhold taxes from the earned income. (E.g.: Uber, Doordash, Lyft).",
        "Health Insurance through the Health Marketplace (E.g.: Obama Care, CuidadoSalud.gov).",
        "If you studied at accredited institutions (E.g.: College and/or University).",
        "Interest generated by student loans.",
        "Homeowner. This form resumes information related to your mortgage (E.g.: Insterest, Principal Payments, Property Taxes, etc.).",
        "If you paid for the care of dependents under 13 years of age. (E.g.: Daycare, Tutoring, etc.).",
        "Stocks. The 1099 Statement is the annual report of your stocks (E.g.: Bitcoin, Robinhood, etc.).",
      ],
      categories: {
        personal: {
          title: "Personal Taxes",
          questions: [
            {
              question: "When is the tax filing deadline?",
              answer:
                "For most individuals, the federal tax filing deadline is April 15. If this date falls on a weekend or holiday, the deadline is typically extended to the next business day.",
            },
            {
              question: "How can I check the status of my tax refund?",
              answer:
                "You can check your refund status using the IRS's \"Where's My Refund?\" tool on their website. You'll need your Social Security number, filing status, and the exact refund amount.",
            },
            {
              question: "What deductions and credits am I eligible for?",
              answer:
                "Eligibility for deductions and credits depends on various factors, including income, filing status, and specific expenses. Common deductions include mortgage interest and charitable contributions, while credits may include the Earned Income Tax Credit and Child Tax Credit.",
            },
            {
              question:
                "How do I file an extension for personal and/or business income taxes?",
              answer:
                "We can file the IRS Form 4868 for you and your business by the original tax deadline. This grants you an additional six months to file your return, moving the deadline to October 15. However, any taxes owed are still due by the original deadline to avoid penalties.",
            },
            {
              question: "What should I do if I can't pay my tax bill?",
              answer:
                "If you're unable to pay your tax bill in full, the IRS offers payment plans and installment agreements. It's important to contact the IRS promptly to discuss your options and avoid additional penalties and interest.",
            },
          ],
        },
        business: {
          title: "Business Taxes",
          questions: [
            {
              question: "What are the different types of business taxes?",
              answer:
                "Businesses may be subject to various taxes, including income tax, self-employment tax, employment taxes, and excise taxes. The specific taxes applicable depend on the business structure and activities.",
            },
            {
              question: "How do I determine my business's tax obligations?",
              answer:
                "Your tax obligations are influenced by your business structure (e.g., sole proprietorship, partnership, corporation) and the nature of your operations. We can help clarify your specific responsibilities.",
            },
            {
              question: "What expenses can I deduct as a business owner?",
              answer:
                "Deductible business expenses must be both ordinary (common in your industry) and necessary (helpful and appropriate for your business). This can include costs like rent, utilities, office supplies, and certain travel expenses.",
            },
            {
              question: "When are estimated tax payments due for businesses?",
              answer:
                "For estimated tax purposes, the year is divided into four payment periods, each with a specific due date: April 15, June 15, September 15, and January 15 of the following year. Timely payments are crucial to avoid penalties.",
            },
          ],
        },
      },
    },
    contact: {
      iframeTitle: "Schedule Appointment",
    },
    footer: {
      quickLinks: "Quick Links",
    },
    scrollToTop: "Scroll to top",
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      services: "Servicios",
      faq: "Preguntas",
      contact: "Contáctenos",
      switchLanguage: "View the site in English",
      call: "Llamar a Tax Solutions",
      callNow: "Llame ahora",
    },
    common: {
      bookAppointment: "Reservar una cita",
      videoUnsupported: "Su navegador no admite la etiqueta de video.",
    },
    hero: {
      heading: "Servicios de contabilidad para",
      words: ["dueños de negocios como usted", "personas como usted"],
    },
    mission:
      "Tax Solutions AS Corp. está comprometida a brindar excelencia en todos sus servicios, sin importar la naturaleza de su negocio. Confiar en nosotros es la clave de su éxito financiero.",
    homeServices: [
      {
        category: "Corporaciones, sociedades y LLC",
        title: "SERVICIOS DE CONTABILIDAD",
        description:
          "Ya sea conciliar cuentas, corregir errores o poner al día registros atrasados, cubrimos todas sus necesidades de contabilidad. Además, recibirá informes financieros mensuales claros para mantenerse informado.",
      },
      {
        category: "Personas y clientes corporativos",
        title: "SERVICIOS DE IMPUESTOS",
        description:
          "Nos aseguramos de que sus estados financieros estén listos para efectos fiscales y verificamos que cumpla plenamente con todas las regulaciones tributarias individuales y corporativas, para que enfrente la temporada de impuestos con confianza.",
      },
    ],
    proactive: {
      message:
        "Manténgase proactivo y preparado para impulsar su negocio, cumpliendo plenamente con las regulaciones tributarias del IRS. Trabajemos con anticipación para encaminarlo hacia un éxito fluido y sin estrés.",
      imageAlt: "Yoel Alvarez trabajando en su escritorio",
    },
    about: {
      heading: "Contabilidad profesional y personalizada",
      founderTitle: "Sobre el fundador",
      founder: [
        "Yoel Alvarez, fundador de Tax Solutions AS Corp., posee una Maestría en Contabilidad con especialización en Impuestos y cuenta con más de 10 años de experiencia profesional en contabilidad, impuestos y gestión financiera.",
        "Desde 2014 ha asistido a cientos de personas y empresas con la preparación de impuestos, los informes financieros y los servicios de contabilidad. Su experiencia profesional abarca impuestos individuales y de negocios, planificación fiscal, teneduría de libros, preparación de estados financieros y cumplimiento ante el IRS.",
        "A lo largo de su carrera, Yoel ha desarrollado una amplia experiencia en la gestión de operaciones financieras, el manejo de regulaciones tributarias complejas y el apoyo a sus clientes para tomar decisiones financieras informadas.",
        "En 2021 fundó Tax Solutions AS Corp., apoyándose en su experiencia profesional y en sus conocimientos especializados en materia tributaria. Su trayectoria refleja una base sólida en principios contables, capacidad analítica para resolver problemas y el compromiso de mantener altos estándares profesionales.",
      ],
      missionTitle: "Nuestra misión",
      mission:
        "Simplificar la complejidad de los requisitos tributarios ofreciendo una orientación profesional y confiable, para que usted pueda enfocarse en lo que más importa para su negocio. Al comprender las necesidades financieras particulares de cada cliente, brindamos soluciones a la medida que garantizan precisión, eficiencia y tranquilidad durante la temporada de impuestos y más allá.",
      visionTitle: "Nuestra visión",
      vision:
        "Nos dedicamos a ofrecer soluciones integrales y con visión de futuro, impulsadas por la tecnología. Nos enfocamos en construir relaciones duraderas con nuestros clientes y en fomentar una cultura empresarial colaborativa y centrada en las personas.",
      imageAlt: "Profesional",
    },
    services: {
      hero: "Permítanos encargarnos de sus finanzas mientras usted se enfoca en hacer crecer su negocio. Ofrecemos una amplia gama de servicios en un solo lugar, garantizando calidad y confiabilidad en cada paso.",
      heading:
        "Servicios y soluciones que podemos ofrecerle para atender sus necesidades",
      items: {
        accounting: "Servicios de contabilidad",
        statements: "Estados financieros",
        filing1099: "Presentación de formularios 1099",
        salesTax: "Cumplimiento del impuesto sobre las ventas",
        reporting: "Informes y análisis personalizados",
        taxReturn: "Presentación de declaraciones de impuestos",
        compliance: "Cumplimiento tributario estatal y federal",
        extension: "Extensión de impuestos",
        estimate: "Estimación de impuestos",
        credits: "Créditos tributarios",
        consulting: "Consultoría de negocios",
      },
      cta: "¿Listo para comenzar? Contáctenos para una consulta.",
    },
    faq: {
      heading: "Preguntas frecuentes",
      checklistTitle: "LISTA DE DOCUMENTOS DE IMPUESTOS",
      checklistIntro:
        "Documentos requeridos y/o necesarios para presentar su declaración de impuestos personales. Debe presentar los que apliquen a su caso.",
      documents: [
        "Empleos que retienen impuestos de los ingresos ganados.",
        "Le pagaron el monto completo sin retenciones, por trabajos que no retienen impuestos de los ingresos ganados. (Ej.: Uber, Doordash, Lyft).",
        "Seguro médico a través del Mercado de Seguros Médicos (Ej.: Obama Care, CuidadoDeSalud.gov).",
        "Si estudió en instituciones acreditadas (Ej.: college y/o universidad).",
        "Intereses generados por préstamos estudiantiles.",
        "Propietario de vivienda. Este formulario resume la información relacionada con su hipoteca (Ej.: intereses, pagos al principal, impuestos sobre la propiedad, etc.).",
        "Si pagó por el cuidado de dependientes menores de 13 años. (Ej.: guardería, tutorías, etc.).",
        "Acciones. El formulario 1099 es el reporte anual de sus inversiones (Ej.: Bitcoin, Robinhood, etc.).",
      ],
      categories: {
        personal: {
          title: "Impuestos personales",
          questions: [
            {
              question:
                "¿Cuál es la fecha límite para presentar la declaración de impuestos?",
              answer:
                "Para la mayoría de las personas, la fecha límite federal para presentar la declaración es el 15 de abril. Si esa fecha cae en fin de semana o día feriado, el plazo normalmente se extiende al siguiente día hábil.",
            },
            {
              question: "¿Cómo puedo consultar el estado de mi reembolso?",
              answer:
                "Puede consultar el estado de su reembolso con la herramienta \"¿Dónde está mi reembolso?\" en el sitio web del IRS. Necesitará su número de Seguro Social, su estado civil para efectos de la declaración y el monto exacto del reembolso.",
            },
            {
              question: "¿A qué deducciones y créditos tengo derecho?",
              answer:
                "La elegibilidad para deducciones y créditos depende de varios factores, entre ellos los ingresos, el estado civil para efectos de la declaración y ciertos gastos específicos. Las deducciones comunes incluyen los intereses hipotecarios y las donaciones caritativas, mientras que los créditos pueden incluir el Crédito Tributario por Ingreso del Trabajo y el Crédito Tributario por Hijos.",
            },
            {
              question:
                "¿Cómo solicito una extensión para mis impuestos personales y/o de negocio?",
              answer:
                "Podemos presentar el Formulario 4868 del IRS por usted y su negocio antes de la fecha límite original. Esto le otorga seis meses adicionales para presentar su declaración, moviendo el plazo al 15 de octubre. Sin embargo, los impuestos adeudados deben pagarse antes de la fecha límite original para evitar multas.",
            },
            {
              question: "¿Qué debo hacer si no puedo pagar mis impuestos?",
              answer:
                "Si no puede pagar la totalidad de sus impuestos, el IRS ofrece planes de pago y acuerdos de pago a plazos. Es importante comunicarse con el IRS cuanto antes para evaluar sus opciones y evitar multas e intereses adicionales.",
            },
          ],
        },
        business: {
          title: "Impuestos de negocios",
          questions: [
            {
              question: "¿Cuáles son los tipos de impuestos para negocios?",
              answer:
                "Los negocios pueden estar sujetos a varios impuestos, entre ellos el impuesto sobre la renta, el impuesto sobre el trabajo por cuenta propia, los impuestos sobre la nómina y los impuestos especiales. Los impuestos aplicables dependen de la estructura y las actividades del negocio.",
            },
            {
              question:
                "¿Cómo determino las obligaciones tributarias de mi negocio?",
              answer:
                "Sus obligaciones tributarias dependen de la estructura de su negocio (por ejemplo, propietario único, sociedad o corporación) y de la naturaleza de sus operaciones. Podemos ayudarle a aclarar sus responsabilidades específicas.",
            },
            {
              question: "¿Qué gastos puedo deducir como dueño de un negocio?",
              answer:
                "Los gastos de negocio deducibles deben ser ordinarios (comunes en su industria) y necesarios (útiles y apropiados para su negocio). Esto puede incluir costos como alquiler, servicios públicos, suministros de oficina y ciertos gastos de viaje.",
            },
            {
              question:
                "¿Cuándo vencen los pagos de impuestos estimados para negocios?",
              answer:
                "Para efectos del impuesto estimado, el año se divide en cuatro periodos de pago, cada uno con su propia fecha de vencimiento: 15 de abril, 15 de junio, 15 de septiembre y 15 de enero del año siguiente. Pagar a tiempo es fundamental para evitar multas.",
            },
          ],
        },
      },
    },
    contact: {
      iframeTitle: "Programar cita",
    },
    footer: {
      quickLinks: "Enlaces rápidos",
    },
    scrollToTop: "Volver arriba",
  },
};

export default translations;
